const minMaxConfig = {
  PARAM_NAME_MIN: "minCost",
  PARAM_NAME_MAX: "maxCost",
  SEARCH_PLACEHOLDER: "Поиск по названию, бренду, артикулу, коду…",
};

export { minMaxConfig };
